import { getStore } from '../../store'

export const getPasscode = () => getStore().getState().info.passcode



// WEBPACK FOOTER //
// ./src/modules/portal-remote/util.js